import { useEffect } from "react";
import { SELECT_TYPE, TEXT_TYPE } from "../../constants/webapp";
import { useFirebase } from "../firebase/useFirebase";
import { PERMISSIONS_API, ROLES_API } from "../../constants/api";
import { addSelectItem } from "../../utils/helpers";

export const useRolesForm = () => {
  const { getData, data } = useFirebase();

  useEffect(() => {
    getData(PERMISSIONS_API);
  }, []);

  const fields = [
    {
      id: "name",
      label: "Role Name",
      type: TEXT_TYPE,
      required: true,
    },
    {
      label: "Permissions",
      type: SELECT_TYPE,
      required: true,
      props: { mode: "multiple" },
      options: data?.map((item) => addSelectItem(item)),
    },
  ];

  function onSubmit() {}

  return { fields, onSubmit, api: ROLES_API };
};
